import React from "react";
import PropTypes from "prop-types";
import Title from "../../Common/Atoms/Title";
import List from "../../Common/Atoms/List";
import Button from "./Button";
import "../../../Statics/Scss/Modules/CallbackList.scss";

const CallbackList = ({ title, listText, description, textButton1, textButton2, modButton1, modButton2, href1, href2, onClick1stButton, onClick2ndButton }) => {
 

  return (
    <div className="mod-callback-list">
      <Title size="--twoxs">{title}</Title>
      {description && <List>{listText}</List>}
      <p className="com-paragraph --arial --font-regular --fourxs">{description}</p>
      {href1 && <Button href={href1} mod={modButton1} label={textButton1} onClick={onClick1stButton} />}
      {href2 && <Button href={href2} mod={modButton2} label={textButton2} onClick={onClick2ndButton} />}
    </div>
  );
};

CallbackList.propTypes = {
  title: PropTypes.string,
  listText: PropTypes.array,
  description: PropTypes.string,
  href1: PropTypes.string,
  href2: PropTypes.string,
  textButton1: PropTypes.string,
  textButton2: PropTypes.string,
  modButton1: PropTypes.string,
  modButton2: PropTypes.string,
};

export default CallbackList;
